import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DayPickerSingleDateController, CalendarDay } from 'react-dates';
import moment from 'moment';
import './MultiDatePicker.css';

export default class MultiDatePicker extends PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      dates: this.props.dates
    };
  }

  handleChange = (date) => {
    const { dates } = this.state;
    const newDates = dates.includes(date) ? dates.filter(d => !date.isSame(d)) : [...dates, date];

    this.setState({ dates: newDates });
    this.props.onChange && this.props.onChange(newDates);
  }

  renderCalendarDay = (props) => {
    const { dates } = this.state;
    const { day, modifiers } = props;

    if (dates.includes(day)) {
      modifiers && modifiers.add('selected');
    } else {
      modifiers && modifiers.delete('selected');
    }

    return (
      <CalendarDay
        {...props}
        modifiers={modifiers}
      />
    );
  }

  render () {
    const { date } = this.props;

    return (
      <DayPickerSingleDateController
        hideKeyboardShortcutsPanel
        focused
        date={moment(date)}
        numberOfMonths={1}
        onDateChange={this.handleChange}
        isOutsideRange={date => {
          const isPast = moment(date).isBefore(moment(this.props.date), 'date');
          const isWeekend = date.day() === 0 || date.day() === 6;
          const isToday = moment(date).isSame(moment(), 'date');

          const hasWeekendsDisabled = this.props.disableWeekends && isWeekend;
          const hasTodayDisabled = this.props.disableToday && isToday;
          const hasPastDisabled = this.props.disablePast && isPast;

          // return date < this.props.date || hasWeekendsDisabled;
          return hasWeekendsDisabled || hasTodayDisabled || hasPastDisabled;
        }}
        renderCalendarDay={this.renderCalendarDay}
      />
    );
  }
}

MultiDatePicker.propTypes = {
  date: PropTypes.instanceOf(Date),
  dates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  disableWeekends: PropTypes.bool,
  disableToday: PropTypes.bool,
  disablePast: PropTypes.bool
};

MultiDatePicker.defaultProps = {
  dates: [],
  disableWeekends: false,
  disableToday: true,
  disablePast: true
};
